import React from 'react';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './pendingReservations.module.scss';
import PendingReservationCard from './pendingReservationCard/PendingReservationCard';
import { showCardSeparator } from '../utils';

function PendingReservationContainer({ reservations, trackCallback = null }) {
  return (
    <Box className={styles.pendingReservationContainer}>
      {reservations.map((reservation, index) => (
        <Box key={reservation.id}>
          <PendingReservationCard
            reservation={reservation}
            trackCallback={trackCallback}
          />
          {showCardSeparator(index, reservations) && (
            <Box className={styles.separator} />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default PendingReservationContainer;
